import {
  FileXIcon,
  FilmStripIcon,
  Icon as PhosphorIcon,
} from '@phosphor-icons/react';
import { Icon, IconKey } from '@sr/ui-library';
import { JSX } from 'react';

export interface IEmptyValueErrorLayoutProps {
  contentType: 'client' | 'no-result' | 'payment' | 'title';
}

type ErrorContentType = {
  content: JSX.Element;
  icon: IconKey | PhosphorIcon;
};

/**
 * @deprecated Use the `Empty` component from `@sr/ui-library` instead.
 */
const EmptyValueErrorLayout = ({
  contentType,
}: IEmptyValueErrorLayoutProps) => {
  const errorTypes: Record<string, ErrorContentType> = {
    client: {
      content: (
        <>
          <h3 className="text-sr-black">
            Looks like you don&rsquo;t have any clients yet.
          </h3>
          <p className="text-base">
            Please contact{' '}
            <a
              className="font-semibold underline"
              href="mailto:support@screenrights.org"
            >
              support@screenrights.org
            </a>
            .
          </p>
        </>
      ),
      icon: 'person',
    },
    'no-result': {
      content: (
        <>
          <h3 className="text-sr-black">No results found</h3>
          <p className="text-base">
            We couldn&apos;t find what you are looking for.
          </p>
        </>
      ),
      icon: 'search',
    },
    payment: {
      content: <h3 className="text-sr-black">No Statements Found</h3>,
      icon: FileXIcon,
    },
    title: {
      content: (
        <>
          <h3 className="text-sr-black">
            Looks like you don&rsquo;t have any titles yet.
          </h3>
          <p className="text-base">
            Please contact{' '}
            <a
              className="font-semibold underline"
              href="mailto:support@screenrights.org"
            >
              support@screenrights.org
            </a>
            .
          </p>
        </>
      ),
      icon: FilmStripIcon,
    },
  };

  return (
    <div className="flex w-full flex-col items-center justify-center gap-8 p-10 text-center">
      <Icon
        className="!size-16 text-read-only-bg"
        icon={errorTypes[contentType].icon}
      />
      {errorTypes[contentType].content}
    </div>
  );
};

export default EmptyValueErrorLayout;
